import { render, staticRenderFns } from "./Documentoscopia.vue?vue&type=template&id=e02bf29e"
import script from "./Documentoscopia.vue?vue&type=script&lang=js"
export * from "./Documentoscopia.vue?vue&type=script&lang=js"
import style0 from "./Documentoscopia.vue?vue&type=style&index=0&id=e02bf29e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports